import { RootState } from 'app/rootReducer'

const rateTypeMap: Record<string, string> = {
  all_in_rate: 'All-in-Rate',
  line_hall: 'Line haul',
  rate_per_mile: 'Rate-per-mile',
  rate_per_mile_fsc: 'Rate-per-mile + FSC',
}

export const carrierEmailSelector = (state: RootState) =>
  state.carrierProposal?.carrier?.email

export const submittedAtSelector = (state: RootState) =>
  state.carrierProposal?.submitted_at

export const requestForProposalSelector = (state: RootState) =>
  state.carrierProposal?.rfp

export const laneErrorsSelector = (state: RootState) =>
  state.carrierProposal?.meta.laneErrors || {}

export const rfpMetaSelector = (state: RootState) => state.carrierProposal?.meta

export const lanesSelector = (state: RootState) => {
  const lanes = state.carrierProposal?.lanes || {}
  return Object.values(lanes)
}

export const isSubmittingLaneSelector = (state: RootState) => {
  return Object.values(state.carrierProposal?.lanes || {}).find(
    (lane) => lane.meta.isSubmitting
  )
}

export const errorSelector = (state: RootState) => {
  return Object.values(state.carrierProposal?.lanes || {})
    .filter(({ meta: { error } }) => error)
    .map(({ meta: { error } }) => error)
    .concat(state.carrierProposal.meta.error)
    .filter(Boolean)
    .join(' ')
}

export const proposalRateTypeSelector = (state: RootState) =>
  rateTypeMap[state?.carrierProposal?.rate_type ?? '']

export const hasProposalSelector = (state: RootState) =>
  Object.values(state?.carrierProposal?.lanes ?? {}).some(
    (lane) => !!lane?.lane_proposal?.rate_price
  )

export const isUploadingSelector = (state: RootState) =>
  state.carrierProposal.meta.isUploading

export const uploadErrorSelector = (state: RootState) =>
  state.carrierProposal.meta.uploadError

export const carrierLogoSelector = (state: RootState) =>
  state.carrierProposal?.rfp?.shipper_logo
